import { Component, HostListener, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { Modal } from '../../../models/component/modal.model';
@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
  standalone: true,
})
export class ConfirmComponent {
  title: InputSignal<string> = input('');
  msg: InputSignal<string> = input('');
  toggle: InputSignal<boolean> = input(false);
  type: InputSignal<Modal.Type> = input<Modal.Type>('error');
  btnConfirmText: InputSignal<string> = input('Confirmer');
  btnCancelText: InputSignal<string> = input('Annuler');

  callback: OutputEmitterRef<boolean> = output();

  @HostListener('document:keydown.enter', ['$event']) onKeydownValidHandler(event: Event) {
    if (this.toggle()) {
      event.preventDefault();
      this.callback.emit(true);
    }
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: Event) {
    if (this.toggle()) {
      event.preventDefault();
      this.callback.emit(false);
    }
  }

  confirm(value: boolean) {
    this.callback.emit(value);
  }
}
